import { Box, Modal } from "@mui/material";
import React, { useEffect, useState , useContext} from "react";
import ButtonTheme from "../ThemeButton/ThemeButton";
import { AuthIcon, CloseCallbackIcon, CreateCallbackIcon, EmployeesIcon, 
	MessagingIcon, OvertimeIcon, PasswordIcon, 
	ReCallbackIcon, ScheduleIcon, InventoryIconNew , ChecklistIconNew } from "../Layout/Svg";
import { useForm } from "react-hook-form";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { toast } from 'react-toastify';
import AuthContext from "../../context/AuthContext";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "620px",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "12px",
    p: 4,
    maxHeight: "90vh",
    overflow: "auto",
};

export default function PermissionModal({
    open = false,
    handleCloseModal,
    empIds,
    removeEmp,
}) {
    const {
        register,
        formState: { errors },
        handleSubmit,
        setError,
        setValue,
        reset,
        watch,
    } = useForm();
    // const { enqueueSnackbar } = useSnackbar();
    const [users, setUsers] = useState();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [anyChange, setAnyChange] = useState(true);
		const { pages } = useContext(AuthContext);

    useEffect(() => {
        if (empIds && open) {
            ApiService.get("/getMultiEmployee/[" + empIds + "]")
                .then(({ data }) => {
                    setLoading(false);
                    setUsers(data.data);
                    if (data.data.length == 1) {
                        let singleEmp = data.data[0];
                        setValue(
                            "Auth_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Auth_Auth"
                            )
                        );
                        setValue(
                            "Pass_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Pass_Auth"
                            )
                        );
                        setValue(
                            "Emp_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Emp_Auth"
                            )
                        );
                        setValue(
                            "Schedule_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Schedule_Auth"
                            )
                        );
                        setValue(
                            "OT_Auth",
                            Object.values(singleEmp.permission).includes(
                                "OT_Auth"
                            )
                        );
                        setValue(
                            "CB_Auth",
                            Object.values(singleEmp.permission).includes(
                                "CB_Auth"
                            )
                        );
                        setValue(
                            "CBCls_Auth",
                            Object.values(singleEmp.permission).includes(
                                "CBCls_Auth"
                            )
                        );
                        setValue(
                            "GR_Auth",
                            Object.values(singleEmp.permission).includes(
                                "GR_Auth"
                            )
                        );
                        setValue(
                            "SMS_Auth",
                            Object.values(singleEmp.permission).includes(
                                "SMS_Auth"
                            )
                        );
                        setValue(
                            "Notes_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Notes_Auth"
                            )
                        );
												setValue(
                            "Inventory_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Inventory_Auth"
                            )
                        );
												setValue(
                            "Checklist_Auth",
                            Object.values(singleEmp.permission).includes(
                                "Checklist_Auth"
                            )
                        );
                    }
                })
                .catch(() => {
                    toast.error("Error")
                    handleCloseModal();
                });
        }
        return () => {
            setUsers();
            reset();
            setLoading(true);
            setAnyChange(true);
        };
    }, [open]);

    useEffect(() => {
        if (users && users.length == 0) {
            handleCloseModal();
        }
    }, [users]);

    let removeEmpAll = (Emp_Code, event) => {
        if (event.target.parentElement) {
            event.target.parentElement.parentElement.classList.add("d-none");
        }
        removeEmp(Emp_Code);
        setUsers(pre => {
            const index = pre.findIndex(
                (element) => element.Emp_Code == Emp_Code
            );
            if (index > -1) {
                pre.splice(index, 1);
            }
            return [...pre];
        });
    };

    const submit = (d) => {
        setSaving(true);
        ApiService.post("/editPermission", {
            EmpIds: empIds,
            ...d,
        })
            .then(({ data }) => {
                setSaving(false);
                toast.success("Saved")
                handleCloseModal();
            })
            .catch(() => {
                setSaving(false);
                toast.error("Error")
                handleCloseModal();
            });
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (type == "change") {
                setAnyChange(false);
            }
        });
        return () => { };
    }, [watch]);

    return (
        <Modal
            open={open}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box className="d-flex justify-content-between mb-5">
                    <h3>Manage Authorities</h3>
                    <ButtonTheme
                        onClick={handleCloseModal}
                        className="p-0 m-0"
                        style={{ borderRadius: "50%", minWidth: "40px" }}
                    >
                        X
                    </ButtonTheme>
                </Box>
                <Box>
                    <p>Selected members</p>
                    <div className="row ">
                        {users &&
                            Object.values(users).map((item) => (
                                <div
                                    key={item.Emp_Code}
                                    className="col-12 col-sm-6  p-0"
                                >
                                    <div className="border rounded-5 p-2 m-2">
                                        <button
                                            onClick={(e) =>
                                                removeEmpAll(item.Emp_Code, e)
                                            }
                                            className="me-1 fw-bolder"
                                            style={{
                                                background: "#FF403F",
                                                color: "#FFF",
                                                border: "none",
                                                borderRadius: "50%",
                                            }}
                                        >
                                            &#9866;
                                        </button>
                                        <span>
                                            {item.employee_assignment?.EA_Rank
                                                ? item.employee_assignment.EA_Rank + " " + item.fullName
                                                : item.fullName}
                                        </span>

                                    </div>
                                </div>
                            ))}
                    </div>
                </Box>
                {!loading && (
                    <form onSubmit={handleSubmit(submit)}>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <AuthIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Authorities</span>
                                <p>Edit authorities </p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("Auth_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <PasswordIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Passwords</span>
                                <p>
                                    Revoke Access and Reset Password (Must have
                                    Authorities){" "}
                                </p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("Pass_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <EmployeesIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Employees</span>
                                <p>Show all my employees</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("Emp_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <ScheduleIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Schedule</span>
                                <p>Simple line explanation for the item</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("Schedule_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <OvertimeIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Overtime</span>
                                <p>Simple line explanation for the item</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("OT_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <CreateCallbackIcon
                                    width="18px"
                                    height="19px"
                                />{" "}
                                <span className="fw-bold ">
                                    Create Callback
                                </span>
                                <p>Simple line explanation for the item</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("CB_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <CloseCallbackIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Close Callback</span>
                                <p>Simple line explanation for the item</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("CBCls_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <ReCallbackIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Recall</span>
                                <p>Simple line explanation for the item</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("GR_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <MessagingIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Messaging</span>
                                <p>Send messages to all users</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("SMS_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <MessagingIcon width="18px" height="19px" />{" "}
                                <span className="fw-bold ">Notes</span>
                                <p>Add or edit notes</p>
                            </div>
                            <div
                                className="form-check form-switch d-flex align-items-center"
                                style={{ height: "50px" }}
                            >
                                <input
                                    style={{ width: "40px", height: "25px" }}
                                    {...register("Notes_Auth")}
                                    id="flexSwitch"
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                />
                            </div>
                        </div>
												{pages.includes('V3_INVENTORY_MODULE') &&
													<div className="d-flex justify-content-between my-3">
															<div>
																	<InventoryIconNew width="18px" height="18px" />{" "}
																	<span className="fw-bold ">Inventory</span>
																	<p>Add or edit Inventory</p>
															</div>
															<div
																	className="form-check form-switch d-flex align-items-center"
																	style={{ height: "50px" }}
															>
																	<input
																			style={{ width: "40px", height: "25px" }}
																			{...register("Inventory_Auth")}
																			id="flexSwitch"
																			className="form-check-input"
																			type="checkbox"
																			role="switch"
																	/>
															</div>
													</div>
												}

												{pages.includes('V3_INVENTORY_MODULE') &&
													<div className="d-flex justify-content-between my-3">
															<div>
																	<ChecklistIconNew width="18px" height="18px" />{" "}
																	<span className="fw-bold ">Checklist</span>
																	<p>Add or edit Checklist</p>
															</div>
															<div
																	className="form-check form-switch d-flex align-items-center"
																	style={{ height: "50px" }}
															>
																	<input
																			style={{ width: "40px", height: "25px" }}
																			{...register("Checklist_Auth")}
																			id="flexSwitch"
																			className="form-check-input"
																			type="checkbox"
																			role="switch"
																	/>
															</div>
													</div>
												}
												
                        <div>
                            <ButtonTheme
                                disabled={saving || anyChange}
                                type="submit"
                                className="w-100"
                                color="primary"
                            >
                                {saving && "Loading..."}
                                {!saving && "Save"}
                            </ButtonTheme>
                        </div>
                    </form>
                )}
                {loading && (
                    <div className="card-body">
                        <h5 className="card-title placeholder-glow">
                            <span className="placeholder col-6"></span>
                        </h5>
                        <p className="card-text placeholder-glow"></p>
                        <div className="row justify-content-between ">
                            <div className="col-2">
                                <span className="placeholder col-8"></span>
                                <span className="placeholder col-12"></span>
                            </div>
                            <a
                                href="#"
                                tabIndex="-1"
                                className="btn btn-primary disabled placeholder col-2"
                            ></a>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    );
}
